import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';

const Avatar = ({ size = 'base', className, children, ...props })=>{
    if (children.length > 2) {
        throw new Error('Avatar can only contain up to 2 characters');
    }
    return jsx("span", {
        className: classNames('cb-avatar', size, className),
        ...props,
        children: children
    });
};
Avatar.displayName = 'Avatar';

export { Avatar, Avatar as default };
//# sourceMappingURL=Avatar.es.js.map
